// extracted by mini-css-extract-plugin
export default {"container":"C2J8DDLgsH7bAh3fo7VC"};